let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("25xxx")).then(() => parcelRequire('bIc4I'));